<div fxLayout="column" fxLayoutAlign="start" class="full-screen">
  <app-header
    (go-back)="goToMain()"
    [title]="getToolbarTitle()"
  ></app-header>
  <div class="container">
    <div class="selected-image-area">
      <!--<img alt="The image that was chosen to be replaced" [src]="_session.getCurrentlySelectedImageFromFile().base64.toString()">-->
      <img
        alt="The image you upload that is to replace the selected image from file"
        i18n-alt
        [src]="imageFromMachine.edited ? imageFromMachine.edited.base64.toString() : imageFromMachine.base64.toString()"
        *ngIf="imageFromMachine"
      >
      <input type="file" hidden #fileInput (change)="onFileUploaded($event.target.files[0])" accept="image/*" />
      <button
        mat-mini-fab
        matTooltip="Upload an image"
        i18n-matTooltip
        matTooltipPosition="above"
        color="accent"
        (click)="openFileUpload()"
      ><mat-icon>publish</mat-icon>
      </button>
    </div>
    <app-oer-formular
      (submit)="replaceByImageFromMachine($event)"
      button-text="Replace"
      i18n-button-text
      [submit-button-disabled]="!imageFromMachine"
      style="max-width: 100% !important; box-sizing: border-box !important;"
    ></app-oer-formular>
  </div>
</div>
